(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/content/suspensionperiod.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/content/suspensionperiod.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.SuspensionPeriod = Marionette.View.extend({
    template: function(data) {
      return svs.spelpaus.templates.suspensionperiod(data);
    },
    modelEvents: {
      'change:type': 'render'
    },
    ui: {
      suspensionPeriod: '.js-suspension-period'
    },
    events: {
      'change @ui.suspensionPeriod': 'onChoosePeriod',
      'focus @ui.suspensionPeriod': 'onFocusCategory',
      'blur @ui.suspensionPeriod': 'onBlurCategory'
    },
    onFocusCategory: function() {
      svs.components.formValidation._onFocus(this.ui.suspensionPeriod);
    },
    onBlurCategory: function() {
      svs.components.formValidation._onBlur(this.ui.suspensionPeriod);
    },
    onChoosePeriod: function() {
      svs.components.formValidation._onChange(this.ui.suspensionPeriod);
      this.model.set('period', this.ui.suspensionPeriod.val());
    }
  });
})(Backbone, _, svs);

 })(window);